import React from 'react';

import { StaffWarning } from '@go-shared/types/staffAllocation';
import { DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT, timeToString } from '@go-shared/lib/time';

import './VenueWarnings.scss';
import { InlineIcon } from '@spark-labs/avocado-ui';

interface VenueWarningsProps {
  warnings: StaffWarning[];
  className?: string;
}
export const VenueWarnings = ({ warnings, className }: VenueWarningsProps) => {
  const classes = ['venue-warnings-wrapper shadow', className || ''];
  return (
    <>
      {warnings.length !== 0 && (
        <div className={classes.join(' ')}>
          <div className="warning-messages-toggleable-box">
            <ul className="warnings-list pt-6 pb-4 pr-4 pl-4 list-none">
              {warnings.map((m, i) => {
                return (
                  <li key={i} className="mb-6 mt-3">
                    <h4 className="mb-1">
                      -There are problems with {m.eventName} at{' '}
                      {timeToString(m.eventStart, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT)}
                    </h4>
                    <h5 className="mb-2">Venue: {m.venueName}</h5>
                    <p className={'text-xs'}>
                      {m.template.title} is assigned at the same time in multiple events
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="warning-icon-wrapper">
            <InlineIcon name="warning-triangle" className="venue-warning-icon" />
          </div>
        </div>
      )}
    </>
  );
};
